import { render } from "./WhoWeAreHome.vue?vue&type=template&id=7c131f14&scoped=true&ts=true"
import script from "./WhoWeAreHome.vue?vue&type=script&lang=ts"
export * from "./WhoWeAreHome.vue?vue&type=script&lang=ts"

import "./WhoWeAreHome.vue?vue&type=style&index=0&id=7c131f14&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c131f14"]])

export default __exports__